<div id="mobile-block">
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.2" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" d="M9 17h6M10 3h4a1 1 0 011 1v13a1 1 0 01-1 1h-4a1 1 0 01-1-1V4a1 1 0 011-1z" />
    <path stroke-linecap="round" stroke-linejoin="round" d="M3 8h3M18 8h3M3 12h3M18 12h3" />
  </svg>
  <h2>Best Viewed on Desktop</h2>
  <p>This experience is designed for desktop and tablet.<br>Please visit on a larger screen.</p>
</div>
<app-cursor />
<app-nav />
<app-hero />
<app-intro />
<app-twigh-showcase />
<app-wilderness-invite />
<app-amenities />
<app-residences />
<app-floorplans />
<app-rooftop />
<app-location />
<app-dream-team />
<app-contact />
<app-footer />
